import { Heading, Text } from '@ankor-io/ui-components'

import { SystemPricing } from '@/components/pricing/system-pricing'
import { useGlobalFeesQuery } from '@/queries/system'

export function Pricing() {
  const { data: systemFees, isPending, isError, error } = useGlobalFeesQuery()

  return (
    <div className="space-y-6">
      <div className="flex md:items-center justify-between gap-2 flex-col md:flex-row">
        <div>
          <Heading level={3}>Pricing</Heading>
          <Text className="mt-2 text-gray-600 dark:text-gray-400">
            Manage global default pricing fees applied to all organizations unless overridden.
          </Text>
        </div>
      </div>
      <SystemPricing
        systemFees={systemFees}
        isPending={isPending}
        isError={isError}
        error={error}
      />
    </div>
  )
}
